import { IconPhoto } from '../icon-photo';
import './index.scss';

export const IconPip: React.FC = () => (
  <div className="icon-pip">
    <IconPhoto />
    <IconPhoto />
  </div>
);
